export default __webpack_public_path__ + "media/vendor/paper-dashboard-2-pro-html-v2.0.1/assets/img/flags/UA-e24827ce192348c8f06fc52f98244a44.png";